import React, { Component, Fragment } from 'react';
import { initGtm, pageLoaded, bundlesLoaded, customEvent } from './helper';

export const GTM_ID = process.env.GOOGLE_TAG_MANAGER_ID;
export const SCRIPT_URL = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
export const IFRAME_URL = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;

/**
 * simple component that outputs the google tag manager & config if the correct
 * env var (GOOGLE_TAG_MANAGER_ID) is set.
 *
 * on mounting, it also establishes the data layer array for the command queue
 * and performs an initial push().
 *
 * also note that technically, the iframe src URL (used when JS is unavailable)
 * should contain the dataLayer with all vars assigned. but alas, we do not know
 * those values in this component since the data has not yet necessarily been
 * resolved.
 *
 */
class GoogleTagManager extends Component {
  static Head() {
    return GTM_ID ? (
      <Fragment>
        <link rel="preconnect" href="https://www.googletagmanager.com" />
        <script defer src={SCRIPT_URL} />
      </Fragment>
    ) : null;
  }

  componentDidMount() {
    initGtm();
  }

  render() {
    return GTM_ID ? (
      <noscript>
        <iframe
          title="gtm"
          src={IFRAME_URL}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    ) : null;
  }
}

GoogleTagManager.triggerPageLoaded = pageLoaded.bind(null);
GoogleTagManager.triggerBundlesLoaded = bundlesLoaded.bind(null);
GoogleTagManager.triggerCustomEvent = customEvent.bind(null);

export default GoogleTagManager;
